import { useQuery } from "@tanstack/react-query";
import { getLicensesShares } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const LICENSE_SHARES_LIST_QUERY_KEY = "LICENSE_SHARES_LIST";

export const licenseSharesListKeys = {
  all: [LICENSE_SHARES_LIST_QUERY_KEY],
};

export const useGetLicenseSharesQuery = () =>
  useQuery({
    queryKey: licenseSharesListKeys.all,
    queryFn: processResponseWithApiProblemDetails(() => getLicensesShares()),
  });
